import { render, staticRenderFns } from "./CMSCustomFieldDetailForm.vue?vue&type=template&id=427a816f&"
import script from "./CMSCustomFieldDetailForm.vue?vue&type=script&lang=js&"
export * from "./CMSCustomFieldDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports